import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from 'src/app/_helpers/alert.service';
import { AuthService } from 'src/app/_services/auth.service';
import { ChatService } from 'src/app/_services/chat_service';
import { CustomerSerivce } from 'src/app/_services/customer_service';
import { RoutingService } from 'src/app/_services/routing.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-chat-customer-listing',
  templateUrl: './chat-customer-listing.component.html',
  styleUrls: ['./chat-customer-listing.component.scss']
})
export class ChatCustomerListingComponent implements OnInit {
  showLoader: boolean = false;
  infoData:any;
  search!: string;
  @ViewChild('ngSearch', { static: false }) ngSearch!: ElementRef;

  constructor(
    private _authService: AuthService,
    private _userService: UserService,
    public routing: RoutingService,
    private chatManagement: ChatService,
    private alertService: AlertService,
    private dialogRef : MatDialog,
    private customerManagment: CustomerSerivce,
  ) { }

  async ngOnInit() {
    await this.getCustomers();
  }

  closeDialog(){
    this.dialogRef.closeAll();
  }

  async getCustomers() {
    this.showLoader = true;
    this.chatManagement.getCustomers()
      .subscribe({
        next: (response: any) => {
          this.showLoader = false;
          if (response && response.isSuccess) {
            this.infoData = response.data;
            this.showLoader = false;
          }
        },
        error: (errorResponse: any) => {
          this.showLoader = false;
          this.alertService.show_alert('Something went Wrong!', '', 'error');
        },
      });
  }

  goToDetailChatManagement(_id: string) {
    this.closeDialog();
    const data: any = {
      customerId: _id,
    };
    this.routing.goToDetailChatManagement(data);
  }


  getSearchData() {
    this.showLoader = true;
    let params: any = {}
    this.search = this.ngSearch?.nativeElement?.value ? this.ngSearch?.nativeElement.value : this.search;
    if(this.search) {
      params['searchFilter'] = `${this.search}`;
    }
    this.infoData = [];
    this.customerManagment.get(params).subscribe({
      next: (response: any) => {
        this.showLoader = false;
        if (response && response.isSuccess) {
          this.infoData = response.data;
        }
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
        this.alertService.show_alert('Something went Wrong!', '', 'error');
      },
    });
  }

  clearSearch() {
    this.ngSearch.nativeElement.value = '';
    // (<HTMLInputElement>document.getElementById('search')).value = '';
    this.search = '';
    this.getCustomers();
  }

}
